export class ViewModelEnviaCobranca {
    dataVencimento: Date;
    dataNovo: Date;
}